import { render, staticRenderFns } from "./FieldSetup.vue?vue&type=template&id=751d2281&scoped=true&"
import script from "./FieldSetup.vue?vue&type=script&lang=ts&"
export * from "./FieldSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d2281",
  null
  
)

export default component.exports